import { logger } from '../../sentry.config'

type TrackVideoOpenedOptions = {
  videoId: string
  locale: string
}

function getVideoPresentation(): 'full_viewport' | 'modal' {
  if (typeof window !== 'undefined' && typeof window.matchMedia === 'function') {
    return window.matchMedia('(max-width: 639px)').matches ? 'full_viewport' : 'modal'
  }

  return 'modal'
}

export function trackVideoOpened({ videoId, locale }: TrackVideoOpenedOptions): void {
  logger.info('family_portal.video_opened', {
    feature: 'home_faq',
    video_id: videoId,
    provider: 'synthesia',
    presentation: getVideoPresentation(),
    locale,
  })
}
